import React, { useMemo } from 'react'
import { isEmpty, size, toLower } from 'lodash'
import PropTypes from 'prop-types'

import { StyledSearchHighlightedSpan } from '../styled'

const SearchHighlightedSpan = ({ searchValue, children }) => {
  const { indexOfSearchValueInNodeName, beforeSearch, afterSearch } =
    useMemo(() => {
      if (isEmpty(searchValue)) {
        return {}
      }

      const indexOfSearchValueInNodeName = toLower(children).indexOf(
        toLower(searchValue),
      )

      return indexOfSearchValueInNodeName > -1
        ? {
            indexOfSearchValueInNodeName,
            beforeSearch: children.substring(0, indexOfSearchValueInNodeName),
            afterSearch: children.substring(
              indexOfSearchValueInNodeName + size(searchValue),
            ),
          }
        : {}
    }, [children, searchValue])

  return indexOfSearchValueInNodeName > -1 ? (
    <>
      {beforeSearch}
      <StyledSearchHighlightedSpan>
        {children.substring(
          indexOfSearchValueInNodeName,
          indexOfSearchValueInNodeName + size(searchValue),
        )}
      </StyledSearchHighlightedSpan>
      {afterSearch}
    </>
  ) : (
    children
  )
}

SearchHighlightedSpan.propTypes = {
  searchValue: PropTypes.string,
  children: PropTypes.string,
}

SearchHighlightedSpan.defaultProps = {
  searchValue: undefined,
  children: null,
}

export default SearchHighlightedSpan
